<template>
  <div>
    <home-section
      id="home-section"
      currentPage="home"
      :cart="cart"
      :business="business"
      :isWebView="IsWebView"
    >
    </home-section>
    <download-section v-if="!IsWebView"></download-section>
    <about-section :business="business" v-if="!IsWebView"></about-section>
  </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import { HomeSection, DownloadSection, AboutSection } from "./components";
import { cartManager, helpers } from "@/utilities";
import SmartBanner from "@/plugins/smart-app-banner/index";
export default {
  name: "home",
  bodyClass: "home-page",
  components: {
    HomeSection,
    DownloadSection,
    AboutSection,
  },
  computed: {
    ...mapGetters(['getStoreLinks']),
    ...mapState({
      business: (state) => state.business,
    }),
    IsWebView() {
      return helpers.IsWebView();
    },
  },
  data() {
    return {
      cart: cartManager.InitCart(),
    };
  },
  methods: {
    refreshDataEventListner() {
      this.$root.$off("REFRESH_CART_DATA");
      this.$root.$on("REFRESH_CART_DATA", () => {
        this.cart = cartManager.getCart();
      });
    },
    initSmartAppBanner() {
      if (!this.getStoreLinks) return;
      new SmartBanner({
        daysHidden: 14, // days to hide banner after close button is clicked (defaults to 15)
        daysReminder: 1, // days to hide banner after "OPEN" button is clicked (defaults to 90)
        title: this.business ? this.business.name : "What The Fork",
        author: "@WhatTheFork",
        button: "Open",
        store: {
          ios: "On the App Store",
          android: "In Google Play",
        },
        price: {
          ios: "FREE",
          android: "FREE",
        },
        appStoreLanguage: "gb",
        // , theme: '' // put platform type ('ios', 'android', etc.) here to force single theme on all device
        icon: this.business ? this.business.logo : null, // full path to icon image if not using website icon image
        isNative: helpers.IsWebView(),
        iosAppId: this.getStoreLinks.appStore,
        androidAppId: this.getStoreLinks.playStore,
      });
    },
  },
  mounted() {
    this.refreshLocationData();
  },
  created() {
    this.refreshDataEventListner();
    this.initSmartAppBanner();
  },
};
</script>

